import { getCalendarStopPeriods } from '../services/api';

export const fileUploadHandler = async (courseId, lessonName, file, fileLink, token, category) => {
  if (!file) {
    throw new Error('No file provided');
  }

  const formData = new FormData();
  formData.append('file', file);
  formData.append('lessonName', lessonName || '');
  formData.append('fileLink', fileLink);
  formData.append('courseId', courseId);
  formData.append('categoryName', category.name);
  formData.append('categoryId', category.id);
  const response = await fetch(`${process.env.REACT_APP_BACKEND_API}/courses/lesson`, {
    method: 'POST',
    body: formData,
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });
  if (!response.ok) {
    throw new Error('File upload failed');
  }

  const data = await response.json();
  return data;
};
export const secondsToHhMmSs = (totalSeconds) => {
  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;

  // Pad single-digit numbers with a leading zero
  const formattedHours = String(hours).padStart(2, '0');
  const formattedMinutes = String(minutes).padStart(2, '0');
  const formattedSeconds = String(seconds).padStart(2, '0');

  return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
};
export const convertToEmbedUrl = (url) => {
  // Handles common YouTube formats
  const regExp = /(?:youtu\.be\/|youtube\.com\/(?:watch\?v=|embed\/))([^\s&]+)/;
  const match = url.match(regExp);
  if (match && match[1]) {
    return `https://www.youtube.com/embed/${match[1]}`;
  }
  return url; // fallback if not YouTube
};

export const createCalendarData = (data) => {
  return data.map((el) => {
    return {
      id: el.id,
      title: el.lesson.title,
      lessonTranslations: el.lesson.translations,
      start: el.date,
      extendedProps: {
        description: el.lesson?.description ?? 'No description',
        score: el?.score ?? 'No score',
        status: el?.status ?? 'Status not provided',
        courseTitle: el.course?.name ?? 'Course title not provided',
        email: el.user?.email,
        userName: `${el.user?.firstName} ${el.user?.lastName}` ?? 'User name not provided',
        category: el.lesson?.category?.name,
        courseTranslations: el.course.translations,
        categoryTranslations: el.lesson.category.translations,
        examLang: el.examLang ?? null,
        googleMeetLink: el.assistantExam ? el.assistantExam.googleMeetLink : null,
        examId: el.id,
        userId: el.user.id,
        examDate: el.date,
        courseId: el.course.id,
        lessonId: el.lesson.id,
        assistant: el.assistant,
      },
    };
  });
};

export const getCalendarStops = async (setter) => {
  try {
    const res = await getCalendarStopPeriods();
    if (res) {
      setter(res);
    }
  } catch (error) {
    console.log('getCalendarStops error', error);
  }
};

export const baseLang = (lang = 'en') => {
  return lang.toLowerCase().split('-')[0];
};

export const makeSlots = (start = '09:30', end = '17:30', stepMin = 15) => {
  const [sh, sm] = start.split(':').map(Number);
  const [eh, em] = end.split(':').map(Number);
  const startMin = sh * 60 + sm;
  const endMin = eh * 60 + em;
  const out = [];
  for (let m = startMin; m <= endMin; m += stepMin) {
    const hh = String(Math.floor(m / 60)).padStart(2, '0');
    const mm = String(m % 60).padStart(2, '0');
    out.push(`${hh}:${mm}`);
  }
  return out;
};
export const unlockBodyScroll = () => {
  const body = document.body;
  body.classList.remove('modal-open');
  body.style.removeProperty('overflow');
  body.style.removeProperty('padding-right');
  document.querySelectorAll('.modal-backdrop').forEach((el) => el.remove());
};
